<template>
    <div class="filter__group row">
        <template v-for="filter in filters">
            <template v-if="filter.type === constants.filterType.select">
                <sal-filter-select :filter="filter"></sal-filter-select>
            </template>
            <template v-if="filter.type === constants.filterType.groupedselection">
                <sal-filter-groupedselect :filter="filter"></sal-filter-groupedselect>
            </template>
            <template v-if="filter.type === constants.filterType.colors">
                <sal-filter-swatch :filter="filter"></sal-filter-swatch>
            </template>
            <template v-if="filter.type === constants.filterType.button">
                <sal-filter-button :filter="filter"></sal-filter-button>
            </template>
            <template v-if="filter.type === constants.filterType.checkboxes">
                <sal-filter-checkboxes :filter="filter"></sal-filter-checkboxes>
            </template>
            <template v-if="filter.type === constants.filterType.checkbox">
                <sal-filter-checkbox :filter="filter"></sal-filter-checkbox>
            </template>
        </template>
    </div>
</template>

<script>
import {constants} from "@productfinder/shared/constants";

import SalFilterSwatchElement from "@productfinder/components/sal-filter-swatch/sal-filter-swatch-element";
import SalFilterSelect from "@productfinder/components/sal-filter-select/sal-filter-select";
import SalFilterSwatch from "@productfinder/components/sal-filter-swatch/sal-filter-swatch";
import SalFilterButton from "@productfinder/components/sal-filter-button/sal-filter-button";
import SalFilterCheckbox from "@productfinder/components/sal-filter-checkbox/sal-filter-checkbox";
import SalFilterCheckboxes from "@productfinder/components/sal-filter-checkboxes/sal-filter-checkboxes";
import SalFilterGroupedselect from '../sal-filter-groupedselect/sal-filter-groupedselect';

export default {
        name: "sal-filter-group",
        components: {SalFilterCheckboxes, SalFilterGroupedselect, SalFilterCheckbox, SalFilterButton, SalFilterSwatch, SalFilterSelect, SalFilterSwatchElement },
        props: {
            filters: Array
        },
        computed: {
            constants() {
                return constants
            },
            typeFilter() {
                return {type: typeof this.filters, data: this.filters}
            }
        }
    }
</script>
